
export default {
  loggedIn: null,
  ssoProvider: null,
  userData: null,

  appBarProgressActive: false,
  appBarOverride: false
}
